export class Answers {
  public ConditionId?: number;
  public TypeRestrictionId?: number;
  public PatientQuestion: string;
  public Answer: string;
  public Value: any;
  public Observation: string;
  public Reference: number;
}
